// extracted by mini-css-extract-plugin
module.exports = {"tabNavItem":"_1W02PZhoT-Cfb0w7QjkwOo","tabNavLink":"_1PgXHUdv9aTEo7MRBceO9c"};